import React from 'react';
import Pagination from 'react-js-pagination';

/**
 * CommonPagination 컴포넌트는 페이지네이션을 관리합니다.
 * @param {Object} props - 페이지 정보와 페이지 변경 핸들러를 포함합니다.
 * @param {Object} props.page - 페이지 정보 (현재 페이지, 총 페이지 수 등)
 * @param {Function} props.onPageChange - 페이지가 변경될 때 호출되는 함수
 */
function CommonPagination({ page, onPageChange, pageRangeDisplayed = 7 }) {

    return (
        <div className="paginationBox">
            {page && page.totalPages > 1 &&
                <Pagination
                    activePage={page.currentPage + 1}
                    itemsCountPerPage={page.size}
                    totalItemsCount={page.totalElements}
                    pageRangeDisplayed={pageRangeDisplayed}
                    onChange={(e)=>onPageChange(e-1)}
                    prevPageText="이전"
                    nextPageText="다음"
                />
            }
        </div>
    );
}

export default CommonPagination;
